import React from 'react';
import { Link } from 'react-router-dom';
import routes from '../../routes.json';
import aroma_ico from '../../assets/images/icons/aroma_poradenstvi.svg';
import lectures_ico from '../../assets/images/icons/lektorska_cinnost.svg';
import exp_ico from '../../assets/images/icons/z_praxe_aromaterapeuta.svg';

const HomepageGuidepost = () => {
  return (
    <div className="row row-guidepost-homepage">
      <div className="container">
        <div className="row">
          <div className="col">
            <Link to={routes.AROMATHERAPY} className="guidepost guidepost-aromatherapy">
              <p className="text">Aromaterapie poradenství</p>
              <img src={aroma_ico} className="ico" alt="aromatherapy" />
              <div className="relative-wrap">
                <span className="btn btn-default">
                  Více
                </span>
              </div>
            </Link>
          </div>
          <div className="col">
            <Link to={routes.CONTACT} className="guidepost guidepost-lectures">
              <p className="text">Lektorská činnost</p>
              <img src={lectures_ico} className="ico" alt="lectures" />
              <div className="relative-wrap">
                <span className="btn btn-default">
                  Více
                </span>
              </div>
            </Link>
          </div>
          <div className="col">
            <Link to={routes.AROMATHERAPY} className="guidepost guidepost-aroexperience">
              <p className="text">Z&nbsp;praxe aromaterapie</p>
              <img src={exp_ico} className="ico" alt="aromatherapy" />
              <div className="relative-wrap">
                <span className="btn btn-default">
                  Více
                </span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomepageGuidepost;